export default __webpack_public_path__ + "static/media/sosLogo.52f182a0.png";